import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useTranslation } from "react-i18next";

export default function MapSelector({
  maps,
  selectedMap,
  setSelectedMap,
  handleSelectedMap,
}) {
  const { t } = useTranslation("warehouse");
  // Create a label function for each option
  const getOptionLabel = (option) => {
    return option ? `${option.name}` : "";
  };

  // Handle change of selected map
  const handleChange = (event, newValue) => {
    if (newValue) {
      setSelectedMap(newValue);
      handleSelectedMap(newValue);
    }
  };

  return (
    <Autocomplete
      disablePortal
      id="combo-box-demo"
      options={maps}
      getOptionLabel={getOptionLabel}
      value={selectedMap}
      onChange={handleChange}
      sx={{ width: 300 }}
      renderInput={(params) => (
        <TextField {...params} size="small" label={t("locations.selectedGraph")} />
      )}
      isOptionEqualToValue={(option, value) => option.id === value.id}
    />
  );
}
